import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrency } from "../../store/currency.slice";
import * as PR from "../../prime-modules/index";

const getSymbol = (code) => {
    try {
        const formatter = new Intl.NumberFormat('en-US', { 
            style: 'currency', 
            currency: code,
            currencyDisplay: 'narrowSymbol'
        });
        const parts = formatter.formatToParts(0);
        const symbolPart = parts.find(part => part.type === 'currency');
        return symbolPart ? symbolPart.value : code;
    } catch (e) {
        return code;
    }
};


const CurrencySelector = ({ inline = false }) => {
    const dispatch = useDispatch();
    const { selectedCurrency, supportedCurrencies } = useSelector(state => state.currency);
    const { currencyMetadata } = useSelector(state => state.language?.activelang || {});

    const currencies = useMemo(() => {
        let metadataMap = {};
        try {
            if (currencyMetadata?.data && currencyMetadata.data !== "undefined") {
                metadataMap = JSON.parse(currencyMetadata.data);
            }
        } catch (e) {
            console.error("Error parsing currency metadata:", e);
        }

        const codes = (supportedCurrencies?.length > 0 ? supportedCurrencies : ['USD']);
        
        return codes.map(code => {
            const metaSymbol = metadataMap?.[code]?.symbol;
            const fallbackSymbol = getSymbol(code);
            
            // If metadata symbol is missing or just the currency code, use the narrow symbol from getSymbol
            return {
                code,
                symbol: (metaSymbol && metaSymbol !== code) ? metaSymbol : fallbackSymbol,
            };
        });

    }, [supportedCurrencies, currencyMetadata]);

    const changeCurrency = (e) => {
        if (e?.value?.code) {
            dispatch(setCurrency(e.value.code));
        }
    };

    const currentCurrency = useMemo(() => 
        currencies.find(c => c.code === selectedCurrency) || currencies[0],
    [currencies, selectedCurrency]);

    const currencyValueTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <span className="currency-symbol mr-2">{option.symbol}</span>
                    <span className="currency-code">{option.code}</span>
                </div>
            );
        }
        return props.placeholder;
    };

    const currencyItemTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <span className="currency-symbol mr-2">{option.symbol}</span>
                <span className="currency-code">{option.code}</span>
            </div>
        );
    };

    if (inline) {
        return (
            <div className="section">
                {currencies.map((curr) => (
                    <div 
                        key={curr.code} 
                        className={`flex align-items-center mb-2 pointer currency-option ${selectedCurrency === curr.code ? 'active' : ''}`} 
                        onClick={() => dispatch(setCurrency(curr.code))}
                    >
                        <span className="currency-symbol mr-2">{curr.symbol}</span>
                        <span className="currency-code">{curr.code}</span>
                    </div>
                ))}
            </div>
        );
    }


    return (
        <div className="currency-selector-container"> 
            <PR.Dropdown 
                value={currentCurrency} 
                onChange={changeCurrency} 
                options={currencies} 
                optionLabel="code" 
                valueTemplate={currencyValueTemplate}
                itemTemplate={currencyItemTemplate}
                className="country-dropdown"
                panelClassName="country-dropdown"
            />
        </div>
    );
};

export default CurrencySelector;

